import styled from 'styled-components';

export const Line = {
  Container: styled.div`
    display: flex;
    margin-bottom: 1rem;
  `,
  Input: styled.div`
    flex: 1;
    margin-right: 0.5rem;
  `,
};

export const ActionSpacer = styled.div`
  width: 45.5px;
  display: flex;
`;

export const Actions = styled.div`
  height: 45.5px;
  display: flex;
`;
